<div>
    <!-- Eingabefeld für die Suche -->
    <input type="text"
           aria-label="Auftraggeber"
           #inputBox
           [attr.id]="inputElemId"
           [attr.maxlength]="maxlength"
           [attr.placeholder]="placeholder"
           [class.error]="fieldModel?.valid === false"
           [disabled]="disabled"
           [title]="title"
           [(ngModel)]="fieldModel.value"
           (keydown)="onInputFieldKeyDown($event)"
           (blur)="onInputFieldBlur($event)">

    <!-- Achtung, wegen CSS-Selektoren, muss dieses Element direkt nach dem Input kommen! Nicht verschieben. -->
    @if (fieldModel?.valid === false) {
        <div
            class="errorMessage"
            [innerHTML]="$safeNavigationMigration(fieldModel?.errorMsg)"></div>
    }

    <!-- Ladeanimation -->
    @if (isLoading()) {
        <i
            class="ico-spinner pos-top-icon input-loading-animation"
            title="Ergebnisse werden geladen..."></i>
    }
</div>

<!-- Vorschlagsliste mit Autocomplete -->
@if (shallShowSuggestionBox) {
    <div
        #suggestionBox
        class="autocomplete-suggestions"
        role="listbox">
        @for (suggestion of filteredSuggestions; track suggestion; let i = $index) {
            <div
                [attr.data-suggestion-index]="i"
                class="autocomplete-suggestions__element"
                role="option"
                tabindex="0"
                (mousedown)="onSuggestionElementMouseDown(suggestion)"
                (keydown)="onSuggestionElementKeyDown($event, suggestion)">
                <div>{{ suggestion.name }}</div>
                <div class="autocomplete-suggestions__secondary">{{ suggestion.plz }} {{ suggestion.ort }}</div>
            </div>
        }
        <div class="autocomplete-suggestions__footer">
            @if (numberOfAdditionalSearchResults > 0) {
                <div
                    class="autocomplete-suggestions__secondary"
                    style="line-height: 1.8;">{{ numberOfAdditionalSearchResults }} {{ numberOfAdditionalSearchResults === 1 ? 'weiteres Ergebnis' : 'weitere Ergebnisse' }}
                </div>
            }
            <div style="margin-left: auto">
                <button type="button"
                        class="icon-button autocomplete-suggestions__footer-button"
                        (mousedown)="onErweiterteSucheBtnClick()"
                        style="margin-left: 0;">
                    <i class="vhvicon vhvicon-search-small icon-button__icon"></i>
                    <span class="icon-button__text">Erweiterte Suche</span>
                </button>
                <button type="button"
                        class="icon-button autocomplete-suggestions__footer-button"
                        (mousedown)="onCloseBtnClick()"
                        style="margin-left: 1rem;">
                    <i class="vhvicon vhvicon-close-small icon-button__icon"></i>
                    <span class="icon-button__text">Schließen</span>
                </button>
            </div>
        </div>
    </div>
}

